import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Game, GameType} from '../../../domain/game';

@Component({
  selector: 'sg-game-type',
  templateUrl: './game-type.component.html',
  styleUrls: ['./game-type.component.scss']
})
export class GameTypeComponent {
  gameType = GameType;
  activatieCode: string;
  activatieCodes = ['00000', '11111', '22222', '33333', '44444', '55555', '12345'];

  @Input() type: GameType;
  @Input() locatie: string;
  @Input() game: Game;
  @Output() typeChange = new EventEmitter<GameType>();
  @Output() locatieChange = new EventEmitter();
  @Output() backButton = new EventEmitter();
  @Output() nextButton = new EventEmitter();

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.key;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
}
